import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/Button";
import ComboBox from "../../../components/ComboBox";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import { Input, Select } from "../../../components/Inputs";
import Loading from "../../../components/Loading/Loading";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import ModalUserLimitUpdate from "../../../components/Modal/ModalUserLimitUpdate";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../../helpers/convert";
import { setNotification } from "../../../helpers/notification";

import {
  getUsersLimitsRequest,
  updateOrganizationLimitsRequest,
} from "../../../redux/actions/organizations";
import { userLookupRequest } from "../../../redux/actions/users";

const UserParameters = ({ t }) => {
  const dispatch = useDispatch();

  const errorMessage = useSelector((state) => state.users.errorMessage);
  const organization = useSelector(
    (state) => state.authorization.user.organization
  );

  let selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );

  const usersParamaterList = useSelector(
    (state) => state.organizations.usersParamaterList
  );

  const loggedInOrganization = usersParamaterList?.organizationLimit;

  const succesMessage = useSelector(
    (state) => state.organizations.succesMessage
  );

  const backError = useSelector((state) => state.organizations.customError);

  const updateParametersCompleted = useSelector(
    (state) => state.organizations.updateParametersCompleted
  );

  const loading = useSelector((state) => state.organizations.loading);
  const error = useSelector((state) => state.organizations.updateError);

  const userList = useSelector((state) => state.users.userList);

  const [userParametersConfirmationModal, setUserParametersConfirmationModal] =
    useState(false);
  const [maxBuyAmountLimit, setMinAmountLimit] = useState();
  const [maxSellAmountLimit, setMaxAmountLimit] = useState();
  const [minSellPriceLimit, setMinPriceLimit] = useState();
  const [maxBuyPriceLimit, setMaxPriceLimit] = useState();
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [activePage, setActivePage] = useState(0);
  const [filterUser, setFilterUser] = useState(null);
  const [changeWindow, setChangeWindow] = useState(false);

  const [selectUser, setSelectUser] = useState(null);

  const usersLimitColumns = [
    {
      name: t("pages.default.YEKGParticipation.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      showTitle: true,
    },
    {
      name: t("pages.default.YEKGParticipation.table.userName"),
      selector: "userName",
      sortable: true,
      showTitle: true,
    },

    {
      name: t("pages.default.userParameters.maxBuyAmountLimit"),
      selector: "maxBuyAmountLimit",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.maxBuyAmountLimit);
      },
    },
    {
      name: t("pages.default.userParameters.maxSellAmountLimit"),
      selector: "maxSellAmountLimit",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.maxSellAmountLimit);
      },
    },
    {
      name: t("pages.default.userParameters.minSellPriceLimit"),
      selector: "minSellPriceLimit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({
          num: row.minSellPriceLimit,
          digit: 2,
        });
      },
    },
    {
      name: t("pages.default.userParameters.maxBuyPriceLimit"),
      selector: "maxBuyPriceLimit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.maxBuyPriceLimit, digit: 2 });
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "process",
      sortable: false,
      width: "140px",
      cell: (row, index) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.review")}
              suffixIcon="edit"
              type="secondary"
              onClick={() => setSelectUser(row)}
              id={`ba-review-${index}`}
            />
          </div>
        );
      },
    },
  ];

  const filterChange = (e) => {
    switch (e.target.name) {
      case "filterUser":
        setFilterUser(e.target.value);
        break;
      default:
        break;
    }
  };

  const filterUserLimit = () => {
    if (!Boolean(selectedOrganization?.organizationId)) {
      setNotification(
        "error",
        t(
          "pages.default.exportTransactions.notifications.selectOrganizationError"
        )
      );
    } else {
      const filters = {
        userId: filterUser,
      };
      if (Boolean(selectedOrganization?.organizationId)) {
        dispatch(
          getUsersLimitsRequest({
            ...filters,
            organizationId: selectedOrganization?.organizationId,
          })
        );
      }
    }
  };

  const updateLimits = () => {
    if (userParametersConfirmationModal) {
      dispatch(
        updateOrganizationLimitsRequest({
          organizationId: selectedOrganization?.organizationId,
          maxBuyAmountLimit: parseInt(maxBuyAmountLimit) || null,
          maxSellAmountLimit: parseInt(maxSellAmountLimit) || null,
          minSellPriceLimit: parseFloat(minSellPriceLimit) ?? null,
          maxBuyPriceLimit: parseFloat(maxBuyPriceLimit) ?? null,
        })
      );
      // setMinAmountLimit(null);
      // setMaxAmountLimit(null);
      // setMinPriceLimit(null);
      // setMaxPriceLimit(null);
      setUserParametersConfirmationModal(false);
    }

    return true;
  };

  useEffect(() => {
    setMinAmountLimit("");
    setMaxAmountLimit("");
    setMinPriceLimit("");
    setMaxPriceLimit("");
    if (Boolean(selectedOrganization?.organizationId)) {
      dispatch(
        userLookupRequest({
          organizationId: selectedOrganization?.organizationId,
        })
      );
    } else {
      dispatch(
        getUsersLimitsRequest({
          organizationId: null,
        })
      );
      dispatch(userLookupRequest({ organizationId: null }));
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (error) {
      setNotification("error", backError);
    }
  }, [error, backError]);

  useEffect(() => {
    if (errorMessage) {
      setNotification("error", errorMessage);
    }
  }, [errorMessage]);
  const limitsChange = (e) => {
    const { value } = e.target;
    if (e.target.name === "maxBuyAmountLimit") {
      setMinAmountLimit(value || null);
    }
    if (e.target.name === "maxSellAmountLimit") {
      setMaxAmountLimit(parseInt(value) || null);
    }
    if (e.target.name === "minSellPriceLimit") {
      setMinPriceLimit(value || null);
    }
    if (e.target.name === "maxBuyPriceLimit") {
      setMaxPriceLimit(value || null);
    }
  };

  useEffect(() => {
    if (updateParametersCompleted) {
      if (changeWindow) {
        setNotification("success", succesMessage?.message);
      }
      dispatch(
        getUsersLimitsRequest({
          organizationId: selectedOrganization?.organizationId ?? null,
        })
      );
      dispatch(
        userLookupRequest({
          organizationId: selectedOrganization?.organizationId ?? null,
        })
      );
    } else if (error) {
    }
  }, [updateParametersCompleted]);

  useEffect(() => {
    if (loggedInOrganization) {
      setMinAmountLimit(loggedInOrganization.maxBuyAmountLimit);
      setMaxAmountLimit(loggedInOrganization.maxSellAmountLimit);
      setMinPriceLimit(loggedInOrganization.minSellPriceLimit);
      setMaxPriceLimit(loggedInOrganization.maxBuyPriceLimit);
    }
  }, [loggedInOrganization]);

  useEffect(() => {
    if (organization) {
      setMinAmountLimit(organization.maxBuyAmountLimit);
      setMaxAmountLimit(organization.maxSellAmountLimit);
      setMinPriceLimit(organization.minSellPriceLimit);
      setMaxPriceLimit(organization.maxBuyPriceLimit);
    }
  }, [organization]);

  const sendUserParametersConfirmationToggle = () => {
    setUserParametersConfirmationModal(true);
    setChangeWindow(true);
  };
  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      getUsersLimitsRequest({
        page: activePage,
        organizationId: selectedOrganization?.organizationId ?? null,
        // selector: selector,
        // direction: direction,
      })
    );
  };
  return (
    <>
      <div className="km__p--redemption-edit-modal-body">
        <>
          <div className="km__p--certificates-filter">
            <ComboBox t={t} />
            <Select
              options={userList?.userLookupList}
              name="filterUser"
              defaultValue={filterUser}
              onChange={filterChange}
            />

            <Button
              type="primary"
              label={t("ui.default.filter")}
              onClick={filterUserLimit}
              id="c-filter"
            />
          </div>

          <div className="km__p--redemption-operations-inputs-container">
            <div className="km__p--redemption-operations-input-title mt-3">
              {t("pages.default.userParameters.OrganizationTitle")}
            </div>
            <br></br>
            <Input
              name="maxBuyAmountLimit"
              type="number"
              min={1}
              max={loggedInOrganization?.checkMaxAmountLimit}
              pattern="[0-9]+([\.,][0-9]+)?"
              maxlength="9"
              placeholder={`${t("pages.default.userParameters.Max")} ${
                loggedInOrganization?.checkMinAmountLimit === undefined ||
                loggedInOrganization?.checkMinAmountLimit === null
                  ? ""
                  : loggedInOrganization?.checkMinAmountLimit
              }`}
              label={t("pages.default.userParameters.maxBuyAmountLimit")}
              value={maxBuyAmountLimit}
              onChange={limitsChange}
            />
            <Input
              name="maxSellAmountLimit"
              type="number"
              min={1}
              max={loggedInOrganization?.checkMaxAmountLimit}
              pattern="[0-9]+([\.,][0-9]+)?"
              maxlength="9"
              placeholder={`${t("pages.default.userParameters.Max")} ${
                loggedInOrganization?.checkMaxAmountLimit === undefined ||
                loggedInOrganization?.checkMaxAmountLimit === null
                  ? ""
                  : loggedInOrganization?.checkMaxAmountLimit
              }`}
              label={t("pages.default.userParameters.maxSellAmountLimit")}
              value={maxSellAmountLimit}
              onChange={limitsChange}
            />
            <Input
              name="minSellPriceLimit"
              type="number"
              min={loggedInOrganization?.checkMinPriceLimit ?? "0"}
              max={loggedInOrganization?.checkMaxPriceLimit}
              pattern="[0-9]+([\.,][0-9]+)?"
              maxlength="9"
              placeholder={`${t("pages.default.userParameters.Min")} ${
                loggedInOrganization?.checkMinPriceLimit === undefined
                  ? ""
                  : loggedInOrganization?.checkMinPriceLimit +
                    " - " +
                    t("pages.default.userParameters.Max") +
                    loggedInOrganization?.checkMaxPriceLimit
              }`}
              acceptDecimal
              label={t("pages.default.userParameters.minSellPriceLimit")}
              value={minSellPriceLimit}
              onChange={limitsChange}
            />

            <Input
              name="maxBuyPriceLimit"
              type="number"
              min={loggedInOrganization?.checkMinPriceLimit}
              max={loggedInOrganization?.checkMaxPriceLimit}
              pattern="[0-9]+([\.,][0-9]+)?"
              maxlength="9"
              placeholder={`${t("pages.default.userParameters.Max")} ${
                loggedInOrganization?.checkMaxPriceLimit === undefined
                  ? ""
                  : loggedInOrganization?.checkMaxPriceLimit +
                    " - " +
                    " Min " +
                    loggedInOrganization?.checkMinPriceLimit
              }`}
              acceptDecimal
              label={t("pages.default.userParameters.maxBuyPriceLimit")}
              value={maxBuyPriceLimit}
              onChange={limitsChange}
            />
            <div></div>
            <div>
              <Button
                type="primary"
                label={t("ui.default.edit")}
                onClick={sendUserParametersConfirmationToggle}
              />
            </div>
          </div>
          {loading ? (
            <Loading text={t("pages.default.userParameters.loading")} />
          ) : usersParamaterList?.items?.length > 0 ? (
            <DataTableServerSideRendering
              columns={usersLimitColumns}
              data={usersParamaterList?.items}
              rowKey="id"
              sortedColumn={sortedColumn}
              setSortedColumn={setSortedColumn}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              pagination
              activePage={activePage}
              totalPageCount={usersParamaterList?.totalPageCount}
              handleFetchData={handleClick}
            />
          ) : (
            ""
          )}
        </>
      </div>
      <ModalConfirmation
        isOpen={userParametersConfirmationModal}
        toggle={() =>
          setUserParametersConfirmationModal(!userParametersConfirmationModal)
        }
        header={t("pages.default.userParameters.confirmation.header")}
        body={t("pages.default.userParameters.confirmation.body")}
        approve={updateLimits}
      />
      <ModalUserLimitUpdate
        toggle={() => setSelectUser()}
        isOpen={selectUser ? true : false}
        selectUser={selectUser}
        loggedInOrganization={loggedInOrganization}
        changeControl={setChangeWindow}
      />
    </>
  );
};

export default UserParameters;
